import React, {ReactNode, useEffect} from 'react';
import classNames from 'clsx';
import {Tooltip} from 'react-bootstrap';

type UpdatingTooltipProps = {
    popper?: { scheduleUpdate: () => void; };
    tooltipKey: string;
    children?: ReactNode;
    show?: any
    // fromProps:
    className?: string; // optional className
    [key: string]: any; // other attributes
}

export const UpdatingTooltip = React.forwardRef<HTMLDivElement, UpdatingTooltipProps>(({
                                                                                           popper,
                                                                                           tooltipKey,
                                                                                           children,
                                                                                           show: _,
                                                                                           ...props
                                                                                       }, ref) => {
    const propsClassName = props?.className ?? '';
    useEffect(() => {
        popper?.scheduleUpdate();
    }, [popper, children]);

    return <Tooltip
        {...props}
        className={classNames(propsClassName, 'hibu-tooltip')}
        ref={ref} id={'tooltip-' + tooltipKey}>
        {children}
    </Tooltip>;
});
